// eslint-disable-next-line no-restricted-exports
export { default } from './Badge';
export * from './Badge';
